<template>
  <b-card
    border-variant="light"
    class="mb-3 bg-light"
    aria-labelledby="modal-size-heading"
  >
    <h6
      id="modal-size-heading"
      class="font-weight-bold mb-1"
    >
      {{ $t('google_ads.modal_size.title') }}
    </h6>
    <p
      id="modal-size-help"
      class="text-muted mb-2"
    >
      {{ $t('google_ads.modal_size.help') }}
    </p>
    <b-row>
      <b-col
        v-for="(device, index) in devices"
        :key="device"
        cols="12"
        md="6"
      >
        <h6 class="d-flex align-items-center font-weight-bold mb-1">
          <feather-icon
            :icon="index === 0 ? 'MonitorIcon' : 'SmartphoneIcon'"
            class="mr-50"
          />
          {{ $t(`google_ads.${device}`) }}
        </h6>
        <b-row>
          <b-col
            v-for="axis in axes"
            :key="axis"
            cols="6"
          >
            <b-form-group
              :label="$t(`google_ads.modal_size.${axis}`)"
              :label-for="`modal-${device}-${axis}`"
            >
              <b-input-group>
                <b-form-input
                  :id="`modal-${device}-${axis}`"
                  :value="dimensionParts(size[axis][index]).number"
                  type="number"
                  min="0"
                  step="any"
                  :placeholder="$t('google_ads.modal_size.auto')"
                  :state="validDimension(size[axis][index]) ? null : false"
                  aria-describedby="modal-size-help"
                  @input="updateNumber(axis, index, $event)"
                />
                <b-input-group-append>
                  <b-form-select
                    :value="selectedUnit(axis, index)"
                    :options="units"
                    :aria-label="unitLabel(axis, device)"
                    @change="updateUnit(axis, index, $event)"
                  />
                </b-input-group-append>
              </b-input-group>
              <small
                v-if="!validDimension(size[axis][index])"
                class="text-danger d-block"
                role="alert"
              >
                {{ $t('google_ads.modal_size.error') }}
              </small>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-button
      size="sm"
      variant="outline-secondary"
      @click="reset"
    >
      {{ $t('google_ads.modal_size.reset') }}
    </b-button>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BFormGroup, BInputGroup, BInputGroupAppend, BFormInput, BFormSelect, BButton,
} from 'bootstrap-vue'
import { validModalDimension, modalDimensionParts } from './modalWindowSize'

export default {
  components: {
    BCard, BRow, BCol, BFormGroup, BInputGroup, BInputGroupAppend, BFormInput, BFormSelect, BButton,
  },
  props: { size: { type: Object, required: true } },
  data: () => ({
    devices: ['desktop', 'mobile'],
    axes: ['width', 'height'],
    units: ['px', '%', 'vw', 'vh', 'rem', 'em'],
    unitOverrides: {},
  }),
  methods: {
    validDimension: validModalDimension,
    dimensionParts: modalDimensionParts,
    unitLabel(axis, device) {
      return this.$t('google_ads.modal_size.unit', {
        dimension: this.$t(`google_ads.modal_size.${axis}`),
        device: this.$t(`google_ads.${device}`),
      })
    },
    selectedUnit(axis, index) {
      return this.unitOverrides[axis + index] || modalDimensionParts(this.size[axis][index]).unit
    },
    updateNumber(axis, index, value) {
      this.$set(this.size[axis], index, value === '' ? '' : value + this.selectedUnit(axis, index))
    },
    updateUnit(axis, index, unit) {
      this.$set(this.unitOverrides, axis + index, unit)
      this.updateNumber(axis, index, modalDimensionParts(this.size[axis][index]).number)
    },
    reset() {
      this.unitOverrides = {}
      this.axes.forEach(axis => this.$set(this.size, axis, ['', '']))
    },
  },
}
</script>
